import React, { useRef, useEffect, useState, memo } from 'react';
import styles from './contentVideo.module.scss';
import { VideoPlayer } from '@components';
import Button from '../button/Button';
import { isHomeEDApp } from '@src/constants';

type Props = {
  data?: string;
  onStart?: () => void;
  metaData?: {};
  isFullScreen?: boolean;
  autoPlay?: boolean;
  onNext?: () => void;
  isVideoFile?: boolean;
  isProgram?: boolean;
  replay?: boolean;
  handleSetReplay?: () => void;
  startLesson?: () => void;
  isPreview?: boolean;
  isNewLessonLayout?: boolean;
  isCollection?: boolean;
  isPlatformTower?: boolean;
};

function ContentVideo(props: Props) {
  const { data, onStart, metaData, isFullScreen, onNext, autoPlay, isVideoFile, isProgram, replay, isPreview=false, isNewLessonLayout=false, isCollection=false, isPlatformTower=false, handleSetReplay, startLesson } = props;
  const [size, setSize] = useState<{ width?: number; height?: number }>({ width: undefined, height: undefined });
  const containerRef = useRef<HTMLDivElement>(null);
  const [isPlaying, setIsPlaying] = useState(false)

  useEffect(() => {
    if (containerRef.current?.clientWidth && containerRef.current?.clientHeight) {
      setSize({ width: containerRef.current?.clientWidth, height: containerRef.current?.clientHeight });
    }
  }, [])

  const handleSetPlay = () => {
    handleSetReplay?.()
    setIsPlaying(true)
  }

  if (!data) return null;

  return (
    <div className={`${styles.wrapper} ${isFullScreen ? styles.isFullScreen : ''}`} ref={containerRef}>
      <VideoPlayer 
        src={data}
        className={`${styles.video} ${isNewLessonLayout ? styles.roundVideo : ''} ${isCollection ? styles.rightRoundVideo: ''}`}
        onStart={onStart}
        metaData={metaData}
        width={size.width}
        height={size.height}
        onNext={onNext}
        autoPlay={autoPlay}
        isVideoFile={isVideoFile} 
        isProgram={isProgram}
        replay={replay}
        handleSetReplay={handleSetPlay}
      />
      {isPreview && !isNewLessonLayout && !isHomeEDApp && !isPlaying && !isPlatformTower ? <div className={styles.previewBeginLesson}>
          <div className={styles.pulse}><Button label={'Begin Lesson'} color='white' className={styles.beginLesson} onClick={() => startLesson && startLesson()} /></div>
      </div> : null}
    </div>
  );
}

export default memo(ContentVideo);
